import React from "react";

const DeleteIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.957"
      height="23.729"
      viewBox="0 0 17.957 23.729"
      fill={fill}
    >
      <g id="db-16" transform="translate(-88 -34)">
        <path
          id="Path_1200"
          data-name="Path 1200"
          d="M187.23,36.939v-.812A2.151,2.151,0,0,0,185.066,34h-3.907A2.15,2.15,0,0,0,179,36.127v.812h1.069v-.812a1.083,1.083,0,0,1,1.1-1.058h3.907a1.086,1.086,0,0,1,1.1,1.058v.812Z"
          transform="translate(-86.137 0)"
        />
        <path
          id="Path_1201"
          data-name="Path 1201"
          d="M125.43,208.231h10.876a1.609,1.609,0,0,0,1.6-1.609L137.936,193H123.8l.027,13.623A1.609,1.609,0,0,0,125.43,208.231Zm8.588-11.619a.534.534,0,0,1,1.069,0v6.91a.534.534,0,1,1-1.069,0Zm-3.688,0a.534.534,0,0,1,1.069,0v6.91a.534.534,0,1,1-1.069,0Zm-3.688,0a.534.534,0,0,1,1.069,0v6.91a.534.534,0,1,1-1.069,0Z"
          transform="translate(-33.887 -150.502)"
        />
        <path
          id="Path_1202"
          data-name="Path 1202"
          d="M105.957,102.42V99.534a.536.536,0,0,0-.534-.534H88.534a.536.536,0,0,0-.534.534v2.886a.536.536,0,0,0,.534.534h16.888A.536.536,0,0,0,105.957,102.42Z"
          transform="translate(0 -61.526)"
        />
      </g>
    </svg>
  );
};

export default DeleteIcon;
